import { Activity, Bike, Dumbbell, Footprints, PersonStanding, Waves } from 'lucide-react'
import type React from 'react'
import styled from 'styled-components'
import { getDisciplineColor } from '../../utils/disciplineColors'
import { LargeIconButton } from './LargeIconButton'

const SelectorContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${({ theme }) => theme.spacing.xs};
`

const SelectorLabel = styled.label`
  font-size: ${({ theme }) => theme.typography.md};
  font-weight: 500;
  color: ${({ theme }) => theme.colors.text};
`

const SelectorGrid = styled.div`
  display: grid;
  grid-template-columns: repeat(6, 1fr);
  gap: ${({ theme }) => theme.spacing.sm};

  @media (max-width: 768px) {
    grid-template-columns: repeat(3, 1fr);
  }

  @media (max-width: 480px) {
    grid-template-columns: repeat(2, 1fr);
  }
`

export type SportType = 'swimming' | 'cycling' | 'running' | 'strength' | 'mobility' | 'other'

interface SportOptionType {
  id: SportType
  label: string
  icon: React.ComponentType<{ className?: string }>
  color: string
}

const sportOptions: SportOptionType[] = [
  {
    id: 'swimming',
    label: 'Swimming',
    icon: Waves,
    color: getDisciplineColor('swimming'),
  },
  {
    id: 'cycling',
    label: 'Cycling',
    icon: Bike,
    color: getDisciplineColor('cycling'),
  },
  {
    id: 'running',
    label: 'Running',
    icon: Footprints,
    color: getDisciplineColor('running'),
  },
  {
    id: 'strength',
    label: 'Strength',
    icon: Dumbbell,
    color: getDisciplineColor('strength'),
  },
  {
    id: 'mobility',
    label: 'Mobility',
    icon: PersonStanding,
    color: getDisciplineColor('mobility'),
  },
  {
    id: 'other',
    label: 'Other',
    icon: Activity,
    color: getDisciplineColor('other'),
  },
]

interface SportSelectorProps {
  value: SportType
  onChange: (sport: SportType) => void
  label?: string
}

export const SportSelector: React.FC<SportSelectorProps> = ({ value, onChange, label = 'Sport' }) => {
  return (
    <SelectorContainer>
      {label && <SelectorLabel>{label}</SelectorLabel>}
      <SelectorGrid>
        {sportOptions.map((option) => (
          <LargeIconButton
            key={option.id}
            selected={value === option.id}
            color={option.color}
            onClick={() => onChange(option.id)}
            icon={option.icon}
            label={option.label}
          />
        ))}
      </SelectorGrid>
    </SelectorContainer>
  )
}
